import { action, global } from '../const';
import { getServerResponse, onException } from '../functions';
import { getUserPersonalDetails } from './Auth';



// [#3 WoogiConnectIdentity.setUpFamily]
export const setUpFamily = (family_name, identity) => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        let message = null;
        dispatch({ type: action.LOADING_DIALOG_TRUE });
        try {
            let response = await getServerResponse({
                cmd: "WoogiConnectIdentity.setUpFamily",
                user_id: userInfo.id,
                family_name,
                identity
            })
            dispatch({ type: action.LOADING_DIALOG_FALSE });
            if (response.error) return;

            if (response === 401) message = "Abuse detected."
            else if (response === 402) message = "Family name exists."
            else if (response === 403) message = "User name exists."
            else if (response === 203) message = "Server error."
            else dispatch(getUserPersonalDetails());
            return { status: response, message }
        } catch (error) {
            dispatch({ type: action.LOADING_DIALOG_FALSE });
            onException(error)
            return { status: 203, message: "Server error." }
        }
    }
};

// #176 WcnFamily.getUserOrganization (Get user family and team(s) if exist.)
export const getUserOrganization = (user_id) => {

    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            let response = await getServerResponse({ cmd: "WcnFamily.getUserOrganization", user_id: user_id || userInfo.id, token: userInfo.token })

            if (response.error) return;

            dispatch({ type: action.USER_TEAMS, payload: response })
            return response
        } catch (error) {
            onException(error, "WcnFamily.getUserOrganization")
            return [];
        }
    }
};

// #5 WoogiConnectIdentity.joinFamily
// export const joinFamily = (user_id) => {

//     return async (dispatch, getState) => {
//         let { invitedUser } = getState().auth;
//         let invited = false
//         try {
//             if (invitedUser && invitedUser !== 404) {
//                 if (invitedUser.family_name || invitedUser.role_type) {
//                     let invitation = {
//                         cmd: "WoogiConnectIdentity.joinFamily",
//                         user_id,
//                         identity: invitedUser.role_type,
//                         family_name: invitedUser.family_name
//                     };
//                     let status = await getServerResponse(invitation);
//                     if (status === 200) invited = true
//                 }
//             }
//         } catch (error) {
//             console.log(error)
//         }
//         return invited;
//     }
// };